import { useSyncExternalStore } from "react";
import { api } from "@/lib/api";

let cfg = null;
let started = false;
const subs = new Set();

export const refreshUi = () => api.get("/ui-config").then(({ data }) => { cfg = data; subs.forEach((f) => f()); }).catch(() => {});
export const setUi = (patch) => { cfg = { ...(cfg || {}), ...patch }; subs.forEach((f) => f()); };
const subscribe = (f) => {
  subs.add(f);
  if (!started) {
    started = true;
    refreshUi();
    setInterval(refreshUi, 60000);
    window.addEventListener("focus", refreshUi);
  }
  return () => subs.delete(f);
};

export const useUi = () => useSyncExternalStore(subscribe, () => cfg);
export const isHidden = (c, id) => (id.startsWith("card-") ? !c?.shown?.includes(id) : !!c?.hidden?.includes(id));
// sort [id, element] pairs by the admin-defined order (unknown ids keep their place at the end)
export const byOrder = (c, pairs) => {
  const o = c?.order || [];
  const rank = (id) => (o.includes(id) ? o.indexOf(id) : 1000);
  return [...pairs].sort((a, b) => rank(a[0]) - rank(b[0]));
};
